import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';

// Shared Components
import { AppInput } from '../../shared/components/app-input/app-input';
import { AppButton } from '../../shared/components/app-button/app-button';
import { AppCheckbox } from '../../shared/components/app-checkbox/app-checkbox';
import { AppAuthHeader } from '../../shared/components/app-auth-header/app-auth-header';
import { AppAuthIntro } from '../../shared/components/app-auth-intro/app-auth-intro';

// Services
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppInput,
    AppButton,
    AppCheckbox,
    AppAuthHeader,
    AppAuthIntro
  ],
  templateUrl: './login.html',
  styles: ``
})
export class Login {
  loginForm: FormGroup;
  loading = signal(false);
  errorMessage = signal('');

  private fb = inject(FormBuilder);
  private router = inject(Router);
  private authService = inject(AuthService);

  constructor() {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      remember: [false]
    });
  }

  onSubmit() {
    if (this.loginForm.invalid) return;

    this.loading.set(true);
    this.errorMessage.set('');

    const { email, password, remember } = this.loginForm.value;

    this.authService.login({ identifier: email, password, rememberMe: remember }).subscribe({
      next: (response: any) => {
        this.loading.set(false);

        if (response?.twoFactorRequired) {
          // Requiere segundo factor - Pasar datos necesarios al componente de 2FA
          this.router.navigate(['/auth/2fa'], { 
            state: { 
              user: response.user, 
              rememberMe: remember 
            } 
          });
        } else {
          // Redirigir con auto=true para que se seleccione automáticamente si es único
          this.router.navigate(['/app/select-business'], { queryParams: { auto: true } });
        }

      },
      error: (err: any) => {
        this.loading.set(false);
        // El mensaje real del backend suele venir en err.error.message
        this.errorMessage.set(err.error?.message || err.message || 'Credenciales inválidas. Intenta de nuevo.');
      }
    });
  }

  goToRegister = () => {
    // Para demostración, podrías redirigir a una ruta de registro si existiera
    console.log('Navegando a Registro...');
  };

  goToForgotPassword = () => {
    this.router.navigate(['/auth/forgot-password']);
  };
}
